
webpack.register(
    'blocks/leaderboard-drawer/statistics/statistics',
    function() {
        return import('blocks/leaderboard-drawer/statistics/statistics');
    },
    true
);